<template>
  <b-col cols="2" md="1" class="d-flex flex-column">
    <b-button
      class="btn-stepper"
      :class="stepperClass"
      :disabled="maxStep < step"
    >
      <template v-if="maxStep > step">
        <svg
          aria-hidden="true"
          focusable="false"
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 512 512"
          class=""
        >
          <path
            fill="currentColor"
            d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
            class=""
          ></path>
        </svg>
      </template>
      <template v-else>
        {{ step }}
      </template>
    </b-button>
    <div class="gd-progress-bar flex-fill" :class="barClass"></div>
  </b-col>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    step: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      status: 0,
    };
  },
  // watch: {
  //   currentStep(val, old) {
  //     console.log('currentStep', val)
  //   },
  //   maxStep(val, old) {
  //     console.log('maxStep', val)
  //   }
  // },
  computed: {
    ...mapState({
      currentStep() {
        return this.$store.getters.currentStep;
      },
      maxStep() {
        return this.$store.getters.maxStep;
      },
    }),
    stepperClass() {
      if (this.currentStep == this.step) {
        return "current-step";
      } else if (this.maxStep < this.step) {
        return "disabled";
      }
      return "";
    },
    barClass() {
      if (this.maxStep == this.step) {
        return "";
      } else if (this.maxStep < this.step) {
        return "unreached";
      } else {
        return "reached";
      }
    },
  },
};
</script>